document.addEventListener('DOMContentLoaded', () => {
  const closeButton = document.querySelector('.aw-membership__banner i');
  const banner = document.querySelector('.aw-membership__banner');
  if (closeButton && banner) {
    closeButton.addEventListener('click', () => {
      banner.classList.add('is-hidden');
      setTimeout(() => {
        banner.style.display = 'none';
      }, 500);
    });
  }
});